/* eslint-disable react/no-array-index-key */
import React, {
  lazy,
  Suspense,
  Fragment
} from 'react';
import {
  Switch,
  Redirect,
  Route
} from 'react-router-dom';
import DashboardLayout from 'src/layouts/MinimalLayout';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/AuthGuard';
import RolGuard from 'src/components/RolGuard';
import GuestGuard from 'src/components/GuestGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: function () {
      return <Redirect to="/login" />
    }
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/privacy-policy',
    component: lazy(() => import('src/views/pages/PrivacyPolicyView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/set-new-pass/:token',
    component: lazy(() => import('src/views/auth/NewPassView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app',
        component: () => <Redirect to="/app/home" />
      },
      {
        exact: true,
        path: '/app/home',
        component: lazy(() => import('src/views/pages/HomeView'))
      },
      {
        exact: true,
        path: '/app/account',
        component: lazy(() => import('src/views/pages/AccountView'))
      },
      {
        exact: true,
        path: '/app/pedidos',
        component: lazy(() => import('src/views/management/Pedidos'))
      },
      {
        exact: true,
        path: '/app/pedidos/:pedidoId',
        component: lazy(() => import('src/views/management/Pedidos'))
      },
      {
        exact: true,
        path: '/app/pedidos/new',
        component: lazy(() => import('src/views/management/Pedidos/new'))
      },
      {
        exact: true,
        path: '/app/descargaDeTemplates',
        component: lazy(() => import('src/views/management/DescargaDeTemplates'))
      },
      {
        exact: true,
        path: '/app/listaDeDocumentos',
        component: lazy(() => import('src/views/management/ListaDeDocumentos'))
      },
      {
        exact: true,
        path: '/app/pedidoLab',
        component: lazy(() => import('src/views/management/PedidoLab'))
      },
      {
        exact: true,
        path: '/app/pedidoLab/new',
        component: lazy(() => import('src/views/management/PedidoLab/new'))
      },
      {
        exact: true,
        path: '/app/pedidosFAR',
        component: lazy(() => import('src/views/management/PedidosFAR'))
      },
      {
        exact: true,
        path: '/app/pedidosFAR/new',
        component: lazy(() => import('src/views/management/PedidosFAR/new'))
      },
      {
        exact: true,
        path: '/app/pedidoEspecialLab',
        component: lazy(() => import('src/views/management/PedidosEspecialLab'))
      },
      {
        exact: true,
        path: '/app/pedidoEspecialLab/new',
        component: lazy(() => import('src/views/management/PedidosEspecialLab/new'))
      },
      {
        exact: true,
        path: '/app/pedidosCC/new',
        component: lazy(() => import('src/views/management/PedidosCC/new'))
      },
      {
        exact: true,
        path: '/app/Documentos',
        component: lazy(() => import('src/views/management/Documentos'))
      },
      {
        exact: true,
        path: '/app/DocumentosFarma',
        component: lazy(() => import('src/views/management/DocumentosFarma'))
      },
      {
        exact: true,
        path: '/app/devolucion',
        component: lazy(() => import('src/views/management/Devoluciones'))
      },
      {
        exact: true,
        path: '/app/devolucion/new',
        component: lazy(() => import('src/views/management/Devoluciones/new'))
      },
      {
        exact: true,
        path: '/app/devolucion/new/:devId',
        component: lazy(() => import('src/views/management/Devoluciones/new'))
      },
      {
        guard: RolGuard,
        routes: [
          {
            exact: true,
            path: '/app/management/abm/user',
            component: lazy(() => import('src/views/management/ABM/User'))
          },
          {
            exact: true,
            path: '/app/management/abm/user/new',
            component: lazy(() => import('src/views/management/ABM/User/Edit'))
          },
          {
            exact: true,
            path: '/app/management/abm/user/:userId',
            component: lazy(() => import('src/views/management/ABM/User/Edit'))
          }
        ]
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
  // ,
  // {
  //   path: '*',
  //   layout: MainLayout,
  //   routes: [
  //     {
  //       exact: true,
  //       path: '/home',
  //       component: HomeView
  //     },
  //     {
  //       component: () => <Redirect to="/404" />
  //     }
  //   ]
  // }
];

const renderRoutes = (routes) => (routes ? (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes
                    ? renderRoutes(route.routes)
                    : <Component {...props} />}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
) : null);

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
